import React from "react";
import { Link } from "react-router-dom";
import { apiGet } from "../../utils/api";
import { useHistory } from "react-router-dom";

const Management = () => {
  const history = useHistory();

  async function testToken() {
    const payload = apiGet("/auth/refresh2");
    return await payload;
  }

  testToken().then(
    (payload) => {},
    (error) => {
      toLogin();
    }
  );

  async function toLogin() {
    history.push("/login");
  }

  return (
    <div>
      <section id="management" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Administração</h2>
        </div>

        <div className="row mx-5">
          <div className="col-md-4">
            <div>
              <Link
                className="btn btn-secondary"
                to="/management/articles/admin"
              >
                Artigos
              </Link>
            </div>
            <div>
              <Link
                className="btn btn-secondary"
                to="/management/members/admin"
              >
                Equipe
              </Link>
            </div>
            <div>
              <Link className="btn btn-secondary" to="/management/news/admin">
                Notícias
              </Link>
            </div>
            <div>
              <Link
                className="btn btn-secondary"
                to="/management/practices/admin"
              >
                Práticas
              </Link>
            </div>
            <div>
              <Link
                className="btn btn-secondary"
                to="/management/projects/admin"
              >
                Projetos
              </Link>
            </div>
            {/*
                
                  <Link
                    className="link link--metis"
                    to="/management/schedule/SchedulesAdmin"
                  >
                    Agenda
                  </Link>
                
                */}
            <div>
              <Link className="btn btn-secondary" to="/management/thesis/admin">
                Teses e Dissertação
              </Link>
            </div>
            <div>
              <Link
                className="btn btn-secondary"
                to="/management/research_groups/admin"
              >
                Grupos de Pesquisa
              </Link>
            </div>
            <div>
              <Link
                className="btn btn-secondary"
                to="/management/study_groups/admin"
              >
                Grupos de Estudo
              </Link>
            </div>
            <div>
              <Link
                className="btn btn-secondary"
                to="/management/observatories/admin"
              >
                Outros Observatórios
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Management;
